export { default } from './RecognizingLeak';
